import React from 'react';
import BootstrapButton from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';

interface Props {
  label: string;
  faIcon?: string;
  onClick: () => void;
  disabled?: boolean;
  /** Affiche un spinner à la place de `faIcon` et désactive le bouton, le temps d'une soumission. */
  loading?: boolean;
}

export const faIconAdd = 'bi bi-plus-circle-fill fs-6 me-2';

function Button({label, onClick, faIcon, disabled, loading = false}: Props) {
  return (
    <BootstrapButton
      variant="celeste-primary"
      size="sm"
      disabled={disabled || loading}
      onClick={onClick}>
      {loading ? (
        <Spinner
          as="span"
          animation="border"
          size="sm"
          role="status"
          aria-hidden="true"
          className="me-2"
        />
      ) : (
        faIcon && <i className={faIcon}></i>
      )}
      {label}
    </BootstrapButton>
  );
}

export default Button;